<template>
  <v-container
    fluid
    cols="12"
    class="d-flex w-100"
  >
    <v-layout
      row
      wrap
    >
      <v-data-table
        :headers="headers"
        :items="errors"
        class="elevation-1 w-100"
      >
        <template v-slot:items="props">
          <td>
            {{ props.item.user_id || '-' }}
          </td>
          <td>
            {{ props.item.message }}
          </td>
        </template>
      </v-data-table>
    </v-layout>
  </v-container>
</template>

<script>

export default {
  name: 'ErrorDetails',
  props: {
    errors: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      headers: [
        { text: 'User ID', value: 'user_id', width: 80 },
        { text: 'Error Message', value: 'message' },
      ],
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/payoutsAndTaxes/payout/shared/ErrorDetails.vue